import { Modal, type ModalProps } from "antd";
import type { ReactNode } from "react";
import { cn } from "../utils/global.utils";
// import CustomTitle from "./CustomTitle";

export interface CustomModalProps extends ModalProps {
  open: boolean;
  size?: number;
  title?: string;
  subTitle?: string;
  description?: string;
  centered?: boolean;
  className?: string;
  children?: ReactNode;
  titleRender?: ReactNode;
  handleClose: () => void;
  disableCloseButton?: boolean;
}

const CustomModal = ({
  open = false,
  size = 360,
  title,
  children,
  className,
  handleClose,
  centered = true,
  closable = true,
  ...rest
}: CustomModalProps) => {
  return (
    <Modal
      title={title}
      open={open}
      width={size}
      footer={null}
      // closable={false}
      centered={centered}
      className={cn("custom-modal", className)}
      onCancel={() => closable && handleClose()}
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
